/*
* Used for rendering gridded forms
* */

import React, { PropsWithChildren } from 'react';
import Container from '../grid/container';
import Row from '../grid/row';
import Col from '../grid/col';
import Typography from '../typography';
import { breakpoints } from '../tokens';

const FormFieldset = ({
    name, children, alignLeft = false,
}: PropsWithChildren<{ name: string, alignLeft?: boolean }>): JSX.Element => (
    <fieldset name={name}>
        <Container>
            <Row>
                <Col breakpoints={{
                    dt: { span: alignLeft ? 3 : 2 },
                    tb: { span: 4 },
                    mb: { span: 4, align: 'center' },
                }}
                >
                    <Typography
                        fontWeight="medium"
                        fontSize={{ dt: 'base' }}
                        css={{
                            textAlign: alignLeft ? 'left' : 'right',
                            margin: 'auto 0',
                            [breakpoints.tb]: {
                                textAlign: 'left',
                            },
                            [breakpoints.mb]: {
                                paddingBottom: '16px',
                                width: '100%',
                            },
                        }}
                    >
                        {name}
                    </Typography>
                </Col>
                <Col breakpoints={{ dt: { span: 6 }, tb: { span: 8 } }}>
                    <div
                        css={{
                            display: 'flex',
                            gap: '8px',
                            flexFlow: 'wrap',
                            '> *': {
                                width: 'calc(50% - 4px)',
                                [breakpoints.tb]: {
                                    width: '100%',
                                },
                            },
                        }}
                    >
                        {children}
                    </div>
                </Col>
            </Row>
        </Container>
    </fieldset>
);

export default FormFieldset;
